export const dashboardModules = [
  {
    key: "sorting",
    title: "Sorting Lab",
    route: "/sorting",
    description: "Compare sorting strategies with benchmark replay, dual-algorithm views, and live step analytics.",
    shortLabel: "Benchmark replay",
    category: "Algorithms",
    lessonsCompleted: 12,
    lessonsTotal: 12,
    progress: 100,
    minutesSpent: 96,
  },
  {
    key: "graph",
    title: "Graph Lab",
    route: "/graph",
    description: "Traverse, debug, and inspect shortest-path and MST algorithms with state-aware graph controls.",
    shortLabel: "Traversal debugger",
    category: "Graphs",
    lessonsCompleted: 9,
    lessonsTotal: 12,
    progress: 72,
    minutesSpent: 78,
  },
  {
    key: "pathfinding",
    title: "Pathfinding Studio",
    route: "/pathfinding",
    description: "Experiment with A*, Dijkstra, BFS, DFS, and greedy search on interactive grid simulations.",
    shortLabel: "Grid search studio",
    category: "Pathfinding",
    lessonsCompleted: 10,
    lessonsTotal: 12,
    progress: 84,
    minutesSpent: 65,
  },
  {
    key: "maze",
    title: "Maze Generator",
    route: "/maze",
    description: "Generate procedural mazes with multiple strategies and capture runs for replay and review.",
    shortLabel: "Maze experiments",
    category: "Simulation",
    lessonsCompleted: 6,
    lessonsTotal: 10,
    progress: 58,
    minutesSpent: 42,
  },
  {
    key: "tree",
    title: "Tree Studio",
    route: "/tree",
    description: "Visualize traversals, balancing ideas, and structural operations on interactive tree stages.",
    shortLabel: "Tree traversals",
    category: "Trees",
    lessonsCompleted: 5,
    lessonsTotal: 10,
    progress: 49,
    minutesSpent: 39,
  },
  {
    key: "linked-list",
    title: "Linked List Lab",
    route: "/linked-list",
    description: "Understand pointers, insertions, reversals, and node operations through animated linked lists.",
    shortLabel: "Pointer fluency",
    category: "Data Structures",
    lessonsCompleted: 7,
    lessonsTotal: 10,
    progress: 68,
    minutesSpent: 44,
  },
  {
    key: "stack",
    title: "Stack Workspace",
    route: "/stack",
    description: "Practice stack operations, state transitions, and sequence reasoning with guided controls.",
    shortLabel: "LIFO practice",
    category: "Core DS",
    lessonsCompleted: 3,
    lessonsTotal: 8,
    progress: 34,
    minutesSpent: 20,
  },
  {
    key: "queue",
    title: "Queue Workspace",
    route: "/queue",
    description: "Work through enqueue and dequeue mechanics with queue-focused structure simulations.",
    shortLabel: "FIFO practice",
    category: "Core DS",
    lessonsCompleted: 2,
    lessonsTotal: 8,
    progress: 28,
    minutesSpent: 18,
  },
];

export const routeModuleMap = dashboardModules.reduce((accumulator, module) => {
  accumulator[module.route] = module;
  return accumulator;
}, {});

export const accentThemeOptions = [
  { value: "blue", label: "Blue" },
  { value: "emerald", label: "Emerald" },
  { value: "amber", label: "Amber" },
  { value: "rose", label: "Rose" },
];

export const dashboardQuickActions = [
  {
    id: "generate-array",
    label: "Generate Array",
    route: "/sorting",
    description: "Jump into a fresh dataset for sorting analysis.",
    moduleKey: "sorting",
    activityTitle: "Generated Array",
    activityDescription: "Prepared a new sorting dataset for practice mode.",
  },
  {
    id: "create-graph",
    label: "Create Graph",
    route: "/graph",
    description: "Open graph controls and build a new traversal scenario.",
    moduleKey: "graph",
    activityTitle: "Created Graph",
    activityDescription: "Opened Graph Lab to construct a new graph state.",
  },
  {
    id: "build-tree",
    label: "Build Tree",
    route: "/tree",
    description: "Resume tree construction and traversal experiments.",
    moduleKey: "tree",
    activityTitle: "Built Tree",
    activityDescription: "Opened Tree Studio to continue structural practice.",
  },
  {
    id: "practice-mode",
    label: "Start Practice Mode",
    route: "/sorting",
    description: "Continue challenge-based drills with guided recommendations.",
    moduleKey: "sorting",
    activityTitle: "Started Practice Mode",
    activityDescription: "Launched a new guided challenge from the dashboard.",
  },
];

export const algorithmCatalog = {
  sorting: 9,
  graph: 11,
  pathfinding: 5,
  maze: 4,
  tree: 4,
  linkedList: 3,
  stackQueue: 3,
};
